export class DropDown {
    items: DropDownItem[];
}

export class DropDownItem {
    constructor(id: number, text: string, code: string) {
        this.id = id;
        this.text = text;
        this.code = code;
    }

    id: number;
    text: string;
    code: string;
}